import { z } from 'zod';
import i18n from '../i18n';

// Tutti i campi `.optional()` (no `.default()`) per allineare input == output
// del tipo inferito da Zod — coerente col pattern produttoreCreateSchema
// e necessario perché react-hook-form Resolver pretende che il TFieldValues
// coincida tra input e output (con `.default([])`, input è `string[] | undefined`
// e output è `string[]`, e il Resolver non riconcilia i due → TS2322/TS2345).
export const omologaCreateSchema = z.object({
  produttore_id: z.string().uuid(i18n.t('richieste.omologa_modal.val_produttore_id')),
  // numero_omologa autogenerato per produttore (#134): non è più input.
  numero_conferimenti: z.number().int().min(1).optional().nullable(),
  frequenza: z.string().optional(),
  pezzatura: z.string().optional(),
  note: z.string().optional(),
  data_firma: z.string().optional(),
  data_scadenza: z.string().optional(),
  trasportatori_ids: z.array(z.string().uuid()).optional(),
  intermediari_ids: z.array(z.string().uuid()).optional(),
});

export const omologaUpdateSchema = z.object({
  // numero_omologa immutabile (autogenerato #134).
  numero_conferimenti: z.number().int().min(1).optional().nullable(),
  frequenza: z.string().optional(),
  pezzatura: z.string().optional(),
  note: z.string().optional(),
  data_firma: z.string().optional(),
  data_scadenza: z.string().optional(),
  trasportatori_ids: z.array(z.string().uuid()).optional(),
  intermediari_ids: z.array(z.string().uuid()).optional(),
});

export type OmologaCreateData = z.infer<typeof omologaCreateSchema>;
export type OmologaUpdateData = z.infer<typeof omologaUpdateSchema>;
